import styled from 'styled-components';
import { size, mediaQueries } from '@everlywell/leaves';
import { Section as RawSection } from './styles';
import Img from 'gatsby-image';

// Brand-centric Hero Styles
export const Section = styled(RawSection)`
  background-color: ${props => props.backgroundColor};
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;

  ${mediaQueries.forTabletHorizontalUp} {
    grid-template-columns: 25% auto 25%;
    align-items: stretch;
    min-height: 350px;
  }
`;

export const TextContainer = styled.div`
  max-width: 720px;
  padding: ${size.sm}px;
  margin: auto;
  ${mediaQueries.forTabletHorizontalUp} {
    max-width: 670px;
    order: 2;
  }
`;

export const MobileImg = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const MailboxWrapper = styled.div`
  display: none;
  ${mediaQueries.forTabletHorizontalUp} {
    display: flex;
    order: 1;
    align-self: stretch;
    max-width: 350px;
  }
`;

export const ResultWrapper = styled.div`
  display: none;
  width: 100%;
  ${mediaQueries.forTabletHorizontalUp} {
    display: flex;
    order: 3;
    align-self: stretch;
    max-width: 350px;
    justify-self: center;
    justify-content: center;
  }
`;

export const Mailbox = styled(Img)`
  margin: 0 ${size.sm}px;
  height: 150px;
  width: 216px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin: 0;
    align-self: flex-end;
    width: 100%;
    height: auto;
    max-height: 80%;
  }
`;
export const Results = styled(Img)`
  margin: 0 ${size.sm}px;
  height: 150px;
  width: 90px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin: 0;
    align-self: flex-end;
    height: 300px;
    width: 100%;
    max-width: 180px;
  }
`;
